import { Box, Typography } from "@mui/material";

type FooterProps = {
  totalGeral: number;
  totalPropria: number;
  totalTerceirizada: number;
};

export const CustomFooter = ({ totalGeral, totalPropria, totalTerceirizada }: FooterProps) => {
  return (
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #e0e0e0' }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 1, textAlign: 'right' }}>
        
        <Typography variant="body2" fontWeight="bold">Valor Total:</Typography>
        <Typography variant="body2" fontWeight="bold" sx={{ minWidth: 50, textAlign: 'center' }}>{totalGeral}</Typography>
        
        <Typography variant="body2">Total Mão de Obra Própria:</Typography>
        <Typography variant="body2" sx={{ minWidth: 50, textAlign: 'center', borderBottom: '1px solid #ccc' }}>{totalPropria}</Typography>
        
        <Typography variant="body2">Total Mão de Obra Terceirizada:</Typography>
        <Typography variant="body2" sx={{ minWidth: 50, textAlign: 'center' }}>{totalTerceirizada}</Typography>
        
      </Box>
    </Box>
  );
};